export const LICENSE_PLATE_REGEX = new RegExp(
  '([A-Z]{2}\\d{4}|\\d{4}[A-Z]{2}|\\d{2}[A-Z]{2}\\d{2}|[A-Z]{2}\\d{2}[A-Z]{2})'
);
